import {
    tabIndex,
    TabName,
} from 'components/WorkspaceEditor/components/TrackChangesPanel/services/ScrollToTreeNode/hooks/useHandleActiveTab'
import { useShallowSelector } from 'components/WorkspaceEditor/Workspace2Store'
import { TrackedChange } from 'models/changes'
import { useMemo } from 'react'

/**
 * Custom hook that determines if the current active tab differs from the tab
 * associated with the provided track change.
 *
 * @param trackChanges - The tracked change to compare against
 * @returns boolean indicating if the tabs are different
 */
export const useIsTabDifferent = (trackChanges?: TrackedChange): boolean => {
    const { activeTab } = useShallowSelector((state) => ({
        activeTab: state.activeTab,
    }))

    return useMemo(() => {
        if (!trackChanges?.partType) return false

        const tab = trackChanges.partType.toLowerCase() as TabName
        return activeTab !== tabIndex[tab]
    }, [activeTab, trackChanges?.partType])
}
